'use client';
import {ReactNode, useState} from 'react';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {AuthProvider, useAuth} from '@/app/hooks/context/AuthContext';
import BannedCheck from "@/app/components/BannedCheck";
import {RainProvider} from '@/app/hooks/context/RainContext';

// Separate wrapper component that uses useAuth INSIDE AuthProvider
function BannedCheckWrapper({children}: { children: ReactNode }) {
    const { user } = useAuth(); //TODO reiketu patubolinti

    return (
        <BannedCheck user={user}>
            {children}
        </BannedCheck>
    );
}

export function Providers({children}: { children: ReactNode }) {
    const [queryClient] = useState(() => new QueryClient());

    return (
        <QueryClientProvider client={queryClient}>
            <AuthProvider>
                <BannedCheckWrapper>
                    {/* Inside AuthProvider — rain state is per-viewer (joined / eligibility). */}
                    <RainProvider>
                        {/*<CartProvider>*/}
                        {children}
                        {/*</CartProvider>*/}
                    </RainProvider>
                </BannedCheckWrapper>
            </AuthProvider>
            <ReactQueryDevtools initialIsOpen={false}/>
        </QueryClientProvider>
    );
}